import { render, staticRenderFns } from "./VoucherManage.vue?vue&type=template&id=18f4d634&scoped=true&"
import script from "./VoucherManage.vue?vue&type=script&lang=js&"
export * from "./VoucherManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4d634",
  null
  
)

export default component.exports